export enum Operations {
    CanManageAndPlaceOrderforProducts
}
